import React from 'react'
import { Link } from "gatsby"
import styled from 'styled-components'

import { FaArrowRight, FaArrowLeft } from 'react-icons/fa';

const Nav = styled.nav`

  a {
    text-decoration: none;
    background: rgba(0,0,0,0.8);
    padding: .8vw;
  }

  svg {
    color: white;
  }

  #next-link, #prev-link {
    position: fixed;
    top: 50%;
    z-index: 10;
    user-select: none;

    display: flex;
    flex-direction: row;
    justify-content: center;
  }

  #next-link {
    position: fixed;
    right:0;

    svg {
    }

    &:hover{
      svg {
        transform: translateX(5px);
        transition: all .2s ease-in-out;
      }
    }
  }

  #prev-link{
    position: fixed;
    left: 0;

    &:hover{
      svg {
        transform: translateX(-5px);
        transition: all .2s ease-in-out;
      }
    }
  }

  p {
    visibility: hidden;
    display: inline;
    opacity: 0;
    margin: 5px;
    transition: opacity .25s ease-in-out;
  }
      
  a:hover > div > p {
      visibility: visible;
      opacity: 1;
  }
`

export default ({ toc, slug }) => {
  const slugName = slug.current
  const slugPos = toc.findIndex(e => e.includes(slugName))

  const nextItem = toc[slugPos + 1]
  const prevItem = toc[slugPos - 1]

  const prevLink = <Link id="prev-link" to={`/${prevItem}`}><FaArrowLeft /></Link>
  const nextLink = <Link id="next-link" to={`/${nextItem}`}><FaArrowRight /></Link>
 

  return (
    <Nav>
      {prevItem ? prevLink : <div></div>}
      {nextItem ? nextLink : <div></div>}
    </Nav>
  )
}